import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from '@component/icon';

import { WHITE } from '@constant/colors';

const Checkbox = ({
  checked,
  className,
  label,
  name,
  onChange,
  tabIndex,
  disabled,
  size,
}) => {
  const labelClassName = classNames('checkboxinput__label', {
    'checkboxinput__label--disabled': disabled,
  });
  const text =
    typeof label === 'string' ? (
      <span
        className={labelClassName}
        dangerouslySetInnerHTML={{ __html: label }}
      />
    ) : (
      <span className={labelClassName}>{label}</span>
    );

  const wrapperClassName = classNames('checkboxinput', className, {
    'checkboxinput--disabled': disabled,
  });
  const checkboxClassName = classNames('checkboxinput__checkbox', {
    'checkboxinput__checkbox--checked': checked,
    'checkboxinput__checkbox--disabled': disabled,
    'checkboxinput__checkbox--small': size === 'small',
    'checkboxinput__checkbox--medium': size === 'medium',
  });

  return (
    <label htmlFor={name} className={wrapperClassName}>
      <input
        className="checkboxinput__field"
        id={name}
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        tabIndex={tabIndex}
        disabled={disabled}
      />
      <span className={checkboxClassName}>
        <Icon
          type="Valid"
          color={WHITE}
          className="checkboxinput__valid-icon"
        />
      </span>
      {text}
    </label>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  tabIndex: PropTypes.number,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'default']),
};

Checkbox.defaultProps = {
  checked: false,
  disabled: false,
  size: 'default',
};

export default Checkbox;
